export default __webpack_public_path__ + "static/media/ic_slash.dd4e9724.svg";